export default function StudentPage() {
  return (
    <div style={{ padding: "120px 20px" }}>
      <h1>Student Page</h1>
    </div>
  );
}



















// // import { motion } from "framer-motion";
// // import {
// //   GraduationCap,
// //   Briefcase,
// //   Users,
// //   BookOpen,
// //   Rocket,
// //   FileText,
// //   CheckCircle
// // } from "lucide-react";

// // const StudentsPage = () => {

// //   const features = [
// //     {
// //       icon: Briefcase,
// //       title: "Internship Opportunities",
// //       desc: "Discover internships with law firms and legal professionals to gain real-world exposure."
// //     },
// //     {
// //       icon: Users,
// //       title: "Connect with Lawyers",
// //       desc: "Build your network by connecting with experienced advocates and mentors."
// //     },
// //     {
// //       icon: BookOpen,
// //       title: "Practical Learning",
// //       desc: "Go beyond theory and understand how real cases are handled in the legal field."
// //     },
// //     {
// //       icon: FileText,
// //       title: "Case Exposure",
// //       desc: "Explore real case structures, documentation, and legal workflows."
// //     },
// //     {
// //       icon: Rocket,
// //       title: "Career Growth",
// //       desc: "Prepare yourself for a successful legal career with guided experience."
// //     },
// //     {
// //       icon: GraduationCap,
// //       title: "Skill Development",
// //       desc: "Improve drafting, research, and analytical skills through hands-on learning."
// //     }
// //   ];

// //   const journey = [
// //     {
// //       title: "Join the Platform",
// //       desc: "Create your profile and start exploring opportunities tailored for law students."
// //     },
// //     {
// //       title: "Discover Opportunities",
// //       desc: "Browse internships, mentorship programs, and real legal work exposure."
// //     },
// //     {
// //       title: "Gain Practical Experience",
// //       desc: "Work alongside lawyers and understand real-world case handling."
// //     },
// //     {
// //       title: "Build Your Career",
// //       desc: "Strengthen your skills, network, and confidence for your future in law."
// //     }
// //   ];

// //   return (
// //     <section className="relative w-full bg-[#f8fafc] overflow-hidden">

// //       {/* Background */}
// //       <div className="absolute inset-0 opacity-[0.04]"
// //         style={{
// //           backgroundImage:
// //             "radial-gradient(circle at 1px 1px, #cda454 1px, transparent 1px)",
// //           backgroundSize: "28px 28px"
// //         }}
// //       />

// //       {/* ================= HERO ================= */}
// //       <div className="max-w-6xl mx-auto px-6 pt-[140px] pb-24 text-center">

// //         <motion.h1
// //           initial={{ opacity: 0, y: 40 }}
// //           animate={{ opacity: 1, y: 0 }}
// //           className="text-[36px] sm:text-[56px] font-extrabold text-[#111]"
// //         >
// //           Designed for
// //           <span className="block text-[#cda454]">Law Students</span>
// //         </motion.h1>

// //         <p className="mt-6 max-w-2xl mx-auto text-[#555] text-[16px] sm:text-[20px]">
// //           Step into the legal world with confidence. Discover opportunities,
// //           connect with professionals, and gain real experience beyond the classroom.
// //         </p>
// //       </div>

// //       {/* ================= MAIN CARD ================= */}
// //       <div className="max-w-4xl mx-auto px-6 pb-24">
// //         <div className="relative">

// //           <div className="absolute -inset-4 bg-[#cda454]/10 blur-2xl rounded-[40px]" />

// //           <div className="relative bg-white/80 backdrop-blur-xl rounded-[40px] p-10 sm:p-14
// //             border border-[#cda454]/10
// //             shadow-[0_25px_80px_rgba(0,0,0,0.08)]">

// //             <p className="text-[16px] sm:text-[18px] text-[#475569] leading-relaxed">
// //               Jurident helps law students bridge the gap between academic learning
// //               and real-world legal practice. Instead of relying only on textbooks,
// //               you gain exposure to how legal work actually happens.
// //             </p>

// //             <div className="my-8 h-[1px] bg-gradient-to-r from-transparent via-[#cda454]/40 to-transparent" />

// //             <p className="text-[16px] sm:text-[18px] text-[#475569] leading-relaxed">
// //               From internships and mentorship to real case understanding,
// //               everything is designed to help you build skills, confidence,
// //               and a strong foundation for your legal career.
// //             </p>

// //           </div>
// //         </div>
// //       </div>

// //       {/* ================= FEATURES ================= */}
// //       <div className="max-w-7xl mx-auto px-6 py-20">

// //         <h2 className="text-center text-[28px] sm:text-[40px] font-bold text-[#111] mb-14">
// //           Learn, Connect, Grow
// //         </h2>

// //         <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">

// //           {features.map((item, index) => {
// //             const Icon = item.icon;
// //             return (
// //               <motion.div
// //                 key={index}
// //                 initial={{ opacity: 0, y: 60 }}
// //                 whileInView={{ opacity: 1, y: 0 }}
// //                 transition={{ duration: 0.6, delay: index * 0.1 }}
// //                 className="bg-white p-6 rounded-2xl border border-[#cda454]/10
// //                 shadow-[0_15px_50px_rgba(0,0,0,0.06)]
// //                 hover:-translate-y-2 transition-all duration-500"
// //               >
// //                 <div className="w-12 h-12 rounded-full bg-[#cda454]/15 flex items-center justify-center mb-4">
// //                   <Icon className="w-5 h-5 text-[#cda454]" />
// //                 </div>

// //                 <h3 className="text-[18px] font-semibold text-[#111] mb-2">
// //                   {item.title}
// //                 </h3>

// //                 <p className="text-[#555] text-[14px] sm:text-[16px]">
// //                   {item.desc}
// //                 </p>
// //               </motion.div>
// //             );
// //           })}

// //         </div>
// //       </div>

// //       {/* ================= JOURNEY ================= */}
// //       <div className="max-w-6xl mx-auto px-6 py-24">

// //         <h2 className="text-[30px] sm:text-[42px] font-bold text-[#111] mb-16">
// //           Your Journey Starts Here
// //         </h2>

// //         <div className="grid md:grid-cols-2 gap-10">

// //           {journey.map((step, i) => (
// //             <div key={i} className="flex gap-4 items-start">

// //               <div className="w-10 h-10 rounded-full bg-[#cda454]/20 flex items-center justify-center flex-shrink-0">
// //                 <CheckCircle className="w-5 h-5 text-[#cda454]" />
// //               </div>

// //               <div>
// //                 <h3 className="text-[18px] font-semibold text-[#111]">
// //                   {step.title}
// //                 </h3>
// //                 <p className="text-[#555] mt-1">
// //                   {step.desc}
// //                 </p>
// //               </div>

// //             </div>
// //           ))}

// //         </div>
// //       </div>

// //       {/* ================= CTA ================= */}
// //       <div className="max-w-5xl mx-auto px-6 pb-32 text-center">

// //         <motion.div
// //           initial={{ opacity: 0, scale: 0.95 }}
// //           whileInView={{ opacity: 1, scale: 1 }}
// //           className="bg-white p-12 rounded-3xl border border-[#cda454]/10
// //           shadow-[0_25px_80px_rgba(0,0,0,0.08)]"
// //         >
// //           <h2 className="text-[28px] sm:text-[36px] font-bold text-[#111]">
// //             Start Building Your Legal Career
// //           </h2>

// //           <p className="mt-4 text-[#555]">
// //             Explore opportunities, learn from professionals, and grow with confidence.
// //           </p>

// //           <button className="mt-6 px-10 py-3 rounded-full bg-[#111] text-white font-semibold hover:scale-105 transition">
// //             Get Started
// //           </button>
// //         </motion.div>

// //       </div>

// //     </section>
// //   );
// // };

// // export default StudentsPage;

























// import { motion } from "framer-motion";
// import {
//   GraduationCap,
//   Briefcase,
//   Users,
//   BookOpen,
//   Rocket,
//   FileText
// } from "lucide-react";

// const StudentsPage = () => {
//   return (
//     <section className="relative w-full bg-[#f8fafc] overflow-hidden">

//       {/* Background Shapes */}
//       <div className="absolute top-[-120px] left-[-120px] w-[300px] h-[300px] bg-[#cda454]/10 rounded-full blur-3xl" />
//       <div className="absolute bottom-[-120px] right-[-120px] w-[300px] h-[300px] bg-[#cda454]/10 rounded-full blur-3xl" />

//       {/* ================= HERO ================= */}
//       <div className="max-w-6xl mx-auto px-6 pt-[140px] pb-32 grid lg:grid-cols-2 gap-16 items-center">

//         {/* LEFT TEXT */}
//         <motion.div
//           initial={{ opacity: 0, y: 40 }}
//           animate={{ opacity: 1, y: 0 }}
//         >
//           <h1 className="text-[38px] sm:text-[56px] font-extrabold text-[#111] leading-tight">
//             Designed for
//             <span className="block text-[#cda454]">Law Students</span>
//           </h1>

//           <p className="mt-6 text-[#555] text-[16px] sm:text-[18px] leading-relaxed">
//             Step beyond textbooks and experience how law works in the real world.
//             Jurident connects you with opportunities, professionals, and practical
//             exposure to help you grow into a confident legal professional.
//           </p>
//         </motion.div>

//         {/* RIGHT FLOATING PANEL */}
//         <motion.div
//           initial={{ opacity: 0, y: 60 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="relative"
//         >
//           <div className="bg-white p-8 rounded-3xl shadow-[0_25px_70px_rgba(0,0,0,0.1)] border border-[#cda454]/10">
//             <p className="text-[#475569] text-[16px] leading-relaxed">
//               Discover internships, connect with practicing lawyers, and gain
//               real exposure to legal workflows — all in one place.
//               Academic knowledge alone isn’t enough. Jurident gives you insight into
//             real case handling, documentation, and how legal professionals work daily.
//             </p>
//           </div>
//         </motion.div>

//       </div>

//       {/* ================= SECTION 1 ================= */}
//       <div className="max-w-6xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

//         {/* LEFT PANEL */}
//         <div className="bg-white p-10 rounded-3xl shadow-[0_20px_60px_rgba(0,0,0,0.08)] border border-[#cda454]/10">
//           <h3 className="text-[20px] font-semibold text-[#111] mb-4">
//             Practical Exposure Matters
//           </h3>
//           <p className="text-[#555] leading-relaxed">
//             Academic knowledge alone isn’t enough. Jurident gives you insight into
//             real case handling, documentation, and how legal professionals work daily.
//             Academic knowledge alone isn’t enough. Jurident gives you insight into
//             real case handling, documentation, and how legal professionals work daily.
//           </p>
//         </div>

//         {/* RIGHT TEXT */}
//         <div>
//           <h2 className="text-[30px] sm:text-[42px] font-bold text-[#111] leading-tight">
//             Learn by
//             <span className="block text-[#cda454]">Doing, Not Just Reading</span>
//           </h2>

//           <p className="mt-6 text-[#555]">
//             Understand the structure of cases, observe real workflows,
//             and gain clarity that textbooks alone cannot provide.
//           </p>
//         </div>

//       </div>

//       {/* ================= SECTION 2 ================= */}
//       <div className="max-w-6xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

//         {/* LEFT TEXT */}
//         <div>
//           <h2 className="text-[30px] sm:text-[42px] font-bold text-[#111]">
//             Build Your
//             <span className="block text-[#cda454]">Legal Network</span>
//           </h2>

//           <p className="mt-6 text-[#555]">
//             Connect with lawyers, mentors, and professionals who can guide you,
//             share insights, and help you grow in your career.
//           </p>
//         </div>

//         {/* RIGHT PANEL */}
//         <div className="bg-white p-10 rounded-3xl shadow-[0_20px_60px_rgba(0,0,0,0.08)] border border-[#cda454]/10">
//           <p className="text-[#555]">
//             <h3 className="text-[20px] font-semibold text-[#111] mb-4">
//             Practical Exposure Matters
//           </h3>
//             Networking early gives you a strong advantage — learn directly from
//             professionals already working in the field.
//             Academic knowledge alone isn’t enough. Jurident gives you insight into
//             real case handling, documentation, and how legal professionals work daily.
//           </p>
//         </div>

//       </div>

//       {/* ================= FEATURE STRIP ================= */}
//       <div className="max-w-6xl mx-auto px-6 py-24 flex flex-wrap justify-center gap-6">

//         {[
//           { icon: Briefcase, text: "Internships" },
//           { icon: Users, text: "Mentorship" },
//           { icon: BookOpen, text: "Practical Learning" },
//           { icon: FileText, text: "Case Exposure" },
//           { icon: Rocket, text: "Career Growth" },
//           { icon: GraduationCap, text: "Skill Development" }
//         ].map((item, i) => {
//           const Icon = item.icon;
//           return (
//             <div key={i} className="flex items-center gap-3 px-6 py-3 bg-white rounded-full border border-[#cda454]/10 shadow-sm">
//               <Icon className="w-4 h-4 text-[#cda454]" />
//               <span className="text-[#333] text-sm font-medium">{item.text}</span>
//             </div>
//           );
//         })}

//       </div>

//       {/* ================= CTA ================= */}
//       <div className="max-w-5xl mx-auto px-6 pb-32 text-center">

//         <div className="bg-white p-12 rounded-3xl border border-[#cda454]/10 shadow-[0_25px_80px_rgba(0,0,0,0.08)]">
//           <h2 className="text-[28px] sm:text-[36px] font-bold text-[#111]">
//             Start Your Legal Journey Today
//           </h2>

//           <p className="mt-4 text-[#555]">
//             Gain experience, build connections, and prepare for your future in law.
//           </p>

//           <button className="mt-6 px-10 py-3 rounded-full bg-[#111] text-white font-semibold hover:scale-105 transition">
//             Join Now
//           </button>
//         </div>

//       </div>

//     </section>
//   );
// };

// export default StudentsPage;

































// import { motion } from "framer-motion";
// import {
//   Bell,
//   Eye,
//   Wallet,
//   FileText,
//   ShieldCheck,
//   Clock,
//   Users,
//   CheckCircle
// } from "lucide-react";

// const ClientsPage = () => {

//   const features = [
//     {
//       icon: Eye,
//       title: "Live Case Tracking",
//       desc: "View the real-time status of your case, including progress updates, filings, and court activity."
//     },
//     {
//       icon: Bell,
//       title: "Instant Hearing Updates",
//       desc: "Get notified instantly about hearing dates, changes, and important legal events."
//     },
//     {
//       icon: Wallet,
//       title: "Expense Transparency",
//       desc: "Track all legal expenses clearly with no hidden costs or confusion."
//     },
//     {
//       icon: FileText,
//       title: "Document Access",
//       desc: "Securely view and download all your case-related documents anytime."
//     },
//     {
//       icon: ShieldCheck,
//       title: "Secure & Private",
//       desc: "Your data is protected with strong encryption and strict privacy controls."
//     },
//     {
//       icon: Clock,
//       title: "24/7 Accessibility",
//       desc: "Access your case information anytime, from anywhere, without delays."
//     }
//   ];

//   const journey = [
//     {
//       title: "Case Registration",
//       desc: "Once your case is initiated, all details are securely recorded and made accessible to you."
//     },
//     {
//       title: "Progress Tracking",
//       desc: "Follow every step of your case as it moves through legal procedures and hearings."
//     },
//     {
//       title: "Regular Updates",
//       desc: "Receive updates directly from your lawyer without needing constant follow-ups."
//     },
//     {
//       title: "Final Outcome",
//       desc: "Access your case results and complete history in one organized place."
//     }
//   ];

//   return (
//     <section className="relative w-full bg-[#f8fafc] overflow-hidden">

//       {/* Background Texture */}
//       <div className="absolute inset-0 opacity-[0.04]"
//         style={{
//           backgroundImage:
//             "radial-gradient(circle at 1px 1px, #cda454 1px, transparent 1px)",
//           backgroundSize: "28px 28px"
//         }}
//       />

//       {/* ================= HERO ================= */}
//       <div className="max-w-6xl mx-auto px-6 pt-[140px] pb-24 text-center">

//         <motion.h1
//           initial={{ opacity: 0, y: 40 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="text-[36px] sm:text-[56px] font-extrabold text-[#111]"
//         >
//           Designed for
//           <span className="block text-[#cda454]">Clients</span>
//         </motion.h1>

//         <p className="mt-6 max-w-2xl mx-auto text-[#555] text-[16px] sm:text-[20px]">
//           Stay informed, stay confident. Track your legal journey with complete clarity,
//           real-time updates, and full transparency all in one simple platform.
//         </p>
//       </div>

//       {/* ================= MAIN CARD ================= */}
//       <div className="max-w-4xl mx-auto px-6 pb-24">
//         <div className="bg-[#e5e7eb] rounded-[40px] p-10 sm:p-14 shadow-inner">

//           <p className="text-[16px] sm:text-[18px] text-[#475569] leading-relaxed">
//             Jurident is built to remove confusion from the legal process. Instead of
//             constantly calling for updates or worrying about your case status, you
//             get everything clearly in one place.
//           </p>

//           <p className="mt-4 text-[16px] sm:text-[18px] text-[#475569] leading-relaxed">
//             From hearing updates and case progress to expenses and documents,
//             everything is transparent, accessible, and easy to understand.
//           </p>

//         </div>
//       </div>

//       {/* ================= FEATURES ================= */}
//       <div className="max-w-7xl mx-auto px-6 py-20">

//         <h2 className="text-center text-[28px] sm:text-[40px] font-bold text-[#111] mb-14">
//           Everything You Need, Clearly Explained
//         </h2>

//         <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">

//           {features.map((item, index) => {
//             const Icon = item.icon;
//             return (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 60 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: index * 0.1 }}
//                 className="bg-white p-6 rounded-2xl border border-[#cda454]/10
//                 shadow-[0_15px_50px_rgba(0,0,0,0.06)]
//                 hover:-translate-y-2 transition-all duration-500"
//               >
//                 <div className="w-12 h-12 rounded-full bg-[#cda454]/15 flex items-center justify-center mb-4">
//                   <Icon className="w-5 h-5 text-[#cda454]" />
//                 </div>

//                 <h3 className="text-[18px] font-semibold text-[#111] mb-2">
//                   {item.title}
//                 </h3>

//                 <p className="text-[#555] text-[14px] sm:text-[16px]">
//                   {item.desc}
//                 </p>
//               </motion.div>
//             );
//           })}

//         </div>
//       </div>

//       {/* ================= JOURNEY ================= */}
//       <div className="max-w-6xl mx-auto px-6 py-24">

//         <h2 className="text-[30px] sm:text-[42px] font-bold text-[#111] mb-16">
//           Your Legal Journey, Simplified
//         </h2>

//         <div className="grid md:grid-cols-2 gap-10">

//           {journey.map((step, i) => (
//             <div key={i} className="flex gap-4 items-start">

//               <div className="w-10 h-10 rounded-full bg-[#cda454]/20 flex items-center justify-center flex-shrink-0">
//                 <CheckCircle className="w-5 h-5 text-[#cda454]" />
//               </div>

//               <div>
//                 <h3 className="text-[18px] font-semibold text-[#111]">
//                   {step.title}
//                 </h3>
//                 <p className="text-[#555] mt-1">
//                   {step.desc}
//                 </p>
//               </div>

//             </div>
//           ))}

//         </div>
//       </div>

//       {/* ================= TRUST SECTION ================= */}
//       <div className="max-w-6xl mx-auto px-6 py-20 text-center">

//         <h2 className="text-[28px] sm:text-[36px] font-bold text-[#111]">
//           Built for Transparency & Trust
//         </h2>

//         <p className="mt-6 max-w-2xl mx-auto text-[#555]">
//           We believe clients deserve clarity, not confusion. Jurident ensures that
//           you always know what’s happening with your case, without needing to chase updates.
//         </p>

//       </div>

//       {/* ================= CTA ================= */}
//       <div className="max-w-5xl mx-auto px-6 pb-32 text-center">

//         <motion.div
//           initial={{ opacity: 0, scale: 0.95 }}
//           whileInView={{ opacity: 1, scale: 1 }}
//           className="bg-white p-12 rounded-3xl border border-[#cda454]/10
//           shadow-[0_25px_80px_rgba(0,0,0,0.08)]"
//         >
//           <h2 className="text-[28px] sm:text-[36px] font-bold text-[#111]">
//             Stay Informed, Stay Confident
//           </h2>

//           <p className="mt-4 text-[#555]">
//             Experience a simpler, clearer way to manage your legal matters.
//           </p>

//           <button className="mt-6 px-10 py-3 rounded-full bg-[#111] text-white font-semibold hover:scale-105 transition">
//             Get Started
//           </button>
//         </motion.div>

//       </div>

//     </section>
//   );
// };

// export default ClientsPage;